import React from 'react';
import './ToggleSwitch.scss';

const ToggleSwitch = ({
  onChange
}) => {
  return (
    <div className="toggle-switch">
      <div className="button r" id="button-1">
        <input type="checkbox" className="checkbox" onChange={(e)=>onChange(e.target.checked)} />
        <div className="knobs"></div>
        <div className="layer"></div>
      </div>
    </div>
  )
}

export default ToggleSwitch;